import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Jumbotron, Row, Container, Button, Col,
    InputGroup, FormControl
} from 'react-bootstrap';
import SpinnerCard from './SpinnerCard';
import { Redirect } from 'react-router-dom'
import { formatFromTo, getMomentDate } from './CalendarUtil';

function BookingRemove() {

    const { licenseName, code } = useParams();
    let [license] = useState(licenseName);
    let [bookingCode] = useState(code);
    let [responseStatus, setResponseStatus] = useState(200);
    let [booking, setBooking] = useState();
    let [confirmed, setConfirmed] = useState(false);
    let [badCode, setBadCode] = useState(false);
    let [email, setEmail] = useState('');

    useEffect(() => {
        if (!confirmed) {
            const fetchData = async () => {
                const res = await fetch(`/api/${license}/booking/${bookingCode}`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                if (res.status !== 200) {
                    setBadCode(true);
                } else {
                    const resJson = await res.json();
                    setBooking(resJson);
                }
            }
            fetchData();
        } else {
            const fetchData = async () => {
                const uri = `/api/${license}/booking/${bookingCode}?email=${email}`
                const res = await fetch(uri,
                    {
                        method: 'DELETE',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                setResponseStatus(res.status);
            }
            fetchData();
        }
        // eslint-disable-next-line
    }, [bookingCode, license, confirmed]);

    function resOK() {
        return responseStatus === 200;
    }

    function resBookingMissing() {
        return responseStatus === 404;
    }

    function res24HourLimit() {
        return responseStatus === 403;
    }

    function isLoading() {
        return booking === undefined;
    }

    function deleteIsConfirmed() {
        return confirmed;
    }

    function showGetConfirmation() {
        var start = getMomentDate(booking.StartTime);
        var end = getMomentDate(booking.EndTime);
        var dateStr = formatFromTo(start, end);
        var note = booking.Note.split('\n');
        return (
            <Jumbotron>
                <h1>Vill du ta bort följande bokning?</h1>
                <br />
                <h3>{dateStr}</h3>
                <br />
                {note.map((n, index) => { return (<h5 key={index}>{n}</h5>) })}
                <br />
                <label htmlFor="email">
                    Ange din e-post för att få en bekräftelse på den borttagna bokningen
                </label>
                <InputGroup className="mb-3">
                    <FormControl
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        id="email"
                        type="email"
                        placeholder="Ange din e-post"
                        aria-label="Ange din e-post"
                    />
                </InputGroup>
                <Button onClick={() => { setConfirmed(true) }}>Ja, ta bort den</Button>
            </Jumbotron >
        );
    }

    function showOK() {
        return (
            <Jumbotron>
                <h1>Din bokning är borttagen!</h1>
                <p>
                    Din bokning är nu borttagen och inte längre giltig.
                </p>
            </Jumbotron>
        );
    }

    function showBookingMissing() {
        return (
            <Jumbotron>
                <h1>Fel</h1>
                <p>
                    Bokningen du försökte ta bort finns inte, eller är redan borttagen.
                </p>
            </Jumbotron>
        );
    }

    function show24HourLimit() {
        return (
            <Jumbotron>
                <h1>Fel</h1>
                <p>
                    Bokningen är inom 24 timmar från nu och går därför inte att ta bort.
                    Kontakta företaget din bokning gäller för ytterligare information.
                </p>
            </Jumbotron>
        );
    }

    function redirectToBooking() {
        var target = `/${licenseName}/booking`;
        return (<Redirect to={target} />);
    }

    function getContent() {
        if (badCode) {
            return redirectToBooking();
        }
        if (isLoading()) {
            return (
                <SpinnerCard />
            );
        } else {
            if (!deleteIsConfirmed()) {
                return showGetConfirmation();
            } else {
                if (resOK()) {
                    return showOK();
                }
                if (resBookingMissing()) {
                    return showBookingMissing();
                }
                if (res24HourLimit()) {
                    return show24HourLimit();
                }
            }
        }
    }

    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col xs={0} s={0} md={1}>
                </Col>
                <Col xs={12} s={12} md={11}>
                    {getContent()}
                </Col>
                <Col xs={0} s={0} md={1}>
                </Col>
            </Row>
        </Container>
    );
}

export default BookingRemove;